import React from "react";
import CircularProgressBar from "../CircularProgressBar";
import "./styles.scss";

const LoanProgressCard = ({
  percentage,
  totalStep,
  currentStep,
  stepHeading,
}) => {
  return (
    <div className="loan-progress-card">
      <CircularProgressBar
        size={70}
        percentage={percentage}
        progressBarClassess={"progress-bar"}
        linecap="round"
        strokeWidth={7}
      />
      <div className="card-text-wrapper">
        <p className="step-counter">{`Step ${currentStep}/${totalStep}`}</p>
        <p className="step-heading">{stepHeading}</p>
      </div>
    </div>
  );
};

export default LoanProgressCard;
